import { notNull } from "../../typescript";

export const joinNames = (specName: string | null, propName: string | null) =>
  notNull(specName)
    ? notNull(propName)
      ? `${specName} • ${propName}`
      : specName
    : null;
